import React from 'react';
import styled from 'styled-components';

import Stack from 'components/Stack';
import Text from 'components/Text';
import { PostShape } from 'utils/props';

import { color } from 'styles/utils';

const StyledTag = styled.div`
  background-color: ${color('lightestBlue')};
  border-radius: 0.5rem;
  text-transform: uppercase;
  padding: 0.25rem 0.75rem;
  width: fit-content;
`;

export default function PostTags({ post }) {
  if (!post.tags?.length) {
    return null;
  }

  return (
    <Stack gap="0.5rem">
      {post.tags.map((tag, index) => (
        <StyledTag key={index}>
          <Text color="teal" variant="smallestP">
            {tag.title}
          </Text>
        </StyledTag>
      ))}
    </Stack>
  );
}

PostTags.propTypes = {
  post: PostShape,
};
